function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ExternalLinkIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M22 2V11H20V5.36584L13.7197 11.6465L12.3057 10.2324L18.5377 4H13V2H22H22ZM18 19C18 19.5518 17.5513 20 17 20H5C4.44873 20 4 19.5518 4 19V7C4 6.44824 4.44873 6 4.99609 6H10V4H5C3.3457 4 2 5.3457 2 7V19C2 20.6543 3.3457 22 5 22H17C18.6543 22 20 20.6543 20 19V14H18V19Z",
    fill: "currentColor"
  }));
}
export function ExternalLinkIconSmall(props) {
  return ___EmotionJSX(ExternalLinkIcon, _extends({
    size: "small"
  }, props));
}